import moment from 'moment';

const Qs = require('qs');

const SurveysService = {
	pmsSettings: {
		get: async (type, teamId) => {
			const response = await axios({
				method: 'get',
				url: `private/surveys/settings/customPms/${type}/${teamId}`,
				baseURL: process.env.MIX_API_URL,
				headers: {
					Authorization: Spark.jwtToken,
					Accept: 'application/json',
					'Content-Type': 'application/json',
				},
			});

			return response.data;
		},
		post: async (type, teamId, settingsData) => {
			try {
				const response = await axios({
					method: 'post',
					url: `private/surveys/settings/customPms/${type}/${teamId}`,
					data: settingsData,
					baseURL: process.env.MIX_API_URL,
					headers: {
						Authorization: Spark.jwtToken,
						Accept: 'application/json',
						'Content-Type': 'application/json',
					},
				});

				return response.data;
			} catch (error) {
				console.error('Error posting PMS Email Settings:', error);
				throw error;
			}
		},
		delete: async (type, teamId) => {
			try {
				const response = await axios({
					method: 'delete',
					url: `private/surveys/settings/customPms/${type}/${teamId}`,
					baseURL: process.env.MIX_API_URL,
					headers: {
						Authorization: Spark.jwtToken,
						Accept: 'application/json',
						'Content-Type': 'application/json',
					},
				});

				return response.data;
			} catch (error) {
				console.error('Error deleting PMS Email Settings:', error);
				throw error;
			}
		},
	},
	settings: {
		index: async () => {
			const response = await axios({
				method: 'get',
				url: 'private/surveys/settings',
				baseURL: process.env.MIX_API_URL,
				headers: {
					Authorization: Spark.jwtToken,
					Accept: 'application/json',
					'Content-Type': 'application/json',
				},
			});

			const responseData = await response.data;
			return responseData;
		},
		update: async (settings) => {
			const response = await axios({
				method: 'put',
				url: 'private/surveys/settings',
				baseURL: process.env.MIX_API_URL,
				data: settings,
				headers: {
					Authorization: Spark.jwtToken,
					Accept: 'application/json',
					'Content-Type': 'application/json',
				},
			});

			const responseData = await response.data;
			return responseData;
		},
		addAlertEmail: async ({ email, type, selectedSurveys }) => {
			try {
				const response = await axios({
					method: 'post',
					url: 'private/surveys/settings/addAlertEmail',
					data: { email, type, selectedSurveys },
					baseURL: process.env.MIX_API_URL,
					headers: {
						Authorization: Spark.jwtToken,
						Accept: 'application/json',
						'Content-Type': 'application/json',
					},
				});

				const responseData = await response;
				return responseData;
			} catch (error) {
				console.error(error);
				return error.data ?? error;
			}
		},
		removeAlertEmail: async (id) => {
			try {
				const response = await axios({
					method: 'delete',
					url: 'private/surveys/settings/removeAlertEmail/' + id,
					baseURL: process.env.MIX_API_URL,
					headers: {
						Authorization: Spark.jwtToken,
						Accept: 'application/json',
						'Content-Type': 'application/json',
					},
				});

				const responseData = await response;
				return responseData;
			} catch (error) {
				console.error(error);
				return error.data ?? error;
			}
		},
		storePmsConnection: async (pms, name, password, domain, extraData = null) => {
			try {
				const response = await axios({
					method: 'post',
					url: 'private/surveys/settings/pms',
					data: {
						pms,
						name,
						password,
						domain,
						extraData
					},
					baseURL: process.env.MIX_API_URL,
					headers: {
						Authorization: Spark.jwtToken,
						Accept: 'application/json',
						'Content-Type': 'application/json',
					},
				});

				const responseData = await response.data;
				return responseData;
			} catch (error) {
				console.error(error);
				return error.data ?? error;
			}
		},
		getPmsConnections: async () => {
			try {
				const response = await axios({
					method: 'get',
					url: 'private/surveys/settings/pms',
					baseURL: process.env.MIX_API_URL,
					headers: {
						Authorization: Spark.jwtToken,
						Accept: 'application/json',
						'Content-Type': 'application/json',
					},
				});

				const responseData = await response.data;
				return responseData;
			} catch (error) {
				console.error(error);
				return error.data ?? error;
			}
		},
		deletePmsConnection: async (connectionId) => {
			try {
				const response = await axios({
					method: 'delete',
					url: `private/surveys/settings/pms/${connectionId}`,
					baseURL: process.env.MIX_API_URL,
					headers: {
						Authorization: Spark.jwtToken,
						Accept: 'application/json',
						'Content-Type': 'application/json',
					},
				});

				const responseData = await response.data;
				return responseData;
			} catch (error) {
				console.error(error);
				return error.data ?? error;
			}
		},
	},
	save: async (data) => {
		let url = 'private/surveys';
		let method = 'post';
		if (data.id) {
			url = 'private/surveys/' + data.id;
			method = 'put';
		}
		const response = await axios({
			method,
			url,
			baseURL: process.env.MIX_API_URL,
			data,
			headers: {
				Authorization: Spark.jwtToken,
				Accept: 'application/json',
				'Content-Type': 'application/json',
			},
		});

		const responseData = await response.data;
		return responseData;
	},

	index: async (page = 1, includeArchived = 0) => {
		const response = await axios({
			method: 'get',
			url: 'private/surveys?page=' + page + '&archived=' + (includeArchived > 0), // Lets just be sure that this is a boolean and not an integer
			baseURL: process.env.MIX_API_URL,
			headers: {
				Authorization: Spark.jwtToken,
				Accept: 'application/json',
				'Content-Type': 'application/json',
			},
		});

		const results = await response.data;
		return results;
	},

	indexAll: async (page = 1) => {
		const response = await axios({
			method: 'get',
			url: `private/surveys/all?page=${page}&archived=true`, // Lets just be sure that this is a boolean and not an integer
			baseURL: process.env.MIX_API_URL,
			headers: {
				Authorization: Spark.jwtToken,
				Accept: 'application/json',
				'Content-Type': 'application/json',
			},
		});

		const results = await response.data;
		return results;
	},

	get: async (id, duplicate = false) => {
		const response = await axios({
			method: 'get',
			url: 'private/surveys/' + id + (duplicate ? '?duplicate=1' : ''),
			baseURL: process.env.MIX_API_URL,
			headers: {
				Authorization: Spark.jwtToken,
				Accept: 'application/json',
				'Content-Type': 'application/json',
			},
		});

		const survey = await response.data;
		return survey;
	},

	getAvailableSurveyImages: async (id) => {
		const response = await axios({
			method: 'get',
			url: 'private/surveys/available-images',
			baseURL: process.env.MIX_API_URL,
			headers: {
				Authorization: Spark.jwtToken,
				Accept: 'application/json',
				'Content-Type': 'application/json',
			},
		});

		const availableSurveyImages = await response.data;
		return availableSurveyImages;
	},

	getSurveyImagesLimit: async () => {
		const response = await axios({
			method: 'get',
			url: 'private/surveys/image-limit',
			baseURL: process.env.MIX_API_URL,
			headers: {
				Authorization: Spark.jwtToken,
				Accept: 'application/json',
				'Content-Type': 'application/json',
			},
		});

		const imageLimit = await response.data.surveyImagesLimit;
		return imageLimit;
	},

	importStats: async (id, stats, year, month) => {
		const response = await axios({
			method: 'post',
			url: 'private/surveys/' + id + '/manual-import',
			data: { stats, year, month },
			baseURL: process.env.MIX_API_URL,
			headers: {
				Authorization: Spark.jwtToken,
				Accept: 'application/json',
				'Content-Type': 'application/json',
			},
		});

		const status = await response.data;
		return status;
	},
	updateStats: async (id, stats, year, month) => {
		const response = await axios({
			method: 'put',
			url: 'private/surveys/' + id + '/manual-import',
			data: { stats, year, month },
			baseURL: process.env.MIX_API_URL,
			headers: {
				Authorization: Spark.jwtToken,
				Accept: 'application/json',
				'Content-Type': 'application/json',
			},
		});

		const status = await response.data;
		return status;
	},
	languages: {
		get: async () => {
			const response = await axios({
				method: 'get',
				url: 'private/languages',
				baseURL: process.env.MIX_API_URL,
				headers: {
					Authorization: Spark.jwtToken,
					Accept: 'application/json',
					'Content-Type': 'application/json',
				},
			});

			const languages = await response.data;
			return languages;
		},
	},
	targets: {
		index: async (surveyId) => {
			const response = await axios({
				method: 'get',
				url: `private/surveys/${surveyId}/targets`,
				baseURL: process.env.MIX_API_URL,
				headers: {
					Authorization: Spark.jwtToken,
					Accept: 'application/json',
					'Content-Type': 'application/json',
				},
			});

			const targets = await response.data;
			return targets;
		},
		create: async (surveyId, targets, year) => {
			const response = await axios({
				method: 'post',
				url: 'private/surveys/' + surveyId + '/targets',
				data: { targets, year },
				baseURL: process.env.MIX_API_URL,
				headers: {
					Authorization: Spark.jwtToken,
					Accept: 'application/json',
					'Content-Type': 'application/json',
				},
			});

			const status = await response.data;
			return status;
		},
	},
	translations: {
		generate: async (surveyId, languageId) => {
			const response = await axios({
				method: 'post',
				url: 'private/translations/generate',
				baseURL: process.env.MIX_API_URL,
				data: { surveyId, languageId },
				headers: {
					Authorization: Spark.jwtToken,
					Accept: 'application/json',
					'Content-Type': 'application/json',
				},
			});

			const translations = await response.data;
			return translations;
		},
		update: async (surveyId, languageId, translations) => {
			const response = await axios({
				method: 'post',
				url: 'private/translations/update',
				baseURL: process.env.MIX_API_URL,
				data: { surveyId, languageId, translations },
				headers: {
					Authorization: Spark.jwtToken,
					Accept: 'application/json',
					'Content-Type': 'application/json',
				},
			});

			const data = await response.data;
			return data;
		},
	},
	stats: async (from, to) => {
		const params = {};

		if (from) params.fromDate = from;
		if (to) params.toDate = to;

		const response = await axios({
			method: 'get',
			url: 'private/stats',
			baseURL: process.env.MIX_API_URL,
			params,
			headers: {
				Authorization: Spark.jwtToken,
				Accept: 'application/json',
				'Content-Type': 'application/json',
			},
		});

		const stats = await response.data;
		return stats;
	},

	surveyStats: async (surveyId, from, to, year = null, answer = null) => {
		const params = {};

		if (from) params.fromDate = from;
		if (to) params.toDate = to;
		if (year) params.year = year;
		if (answer) params.answerId = answer;

		const response = await axios({
			method: 'get',
			url: 'private/stats/' + surveyId,
			baseURL: process.env.MIX_API_URL,
			params,
			headers: {
				Authorization: Spark.jwtToken,
				Accept: 'application/json',
				'Content-Type': 'application/json',
			},
		});

		const stats = await response.data;
		return stats;
	},

	surveyStatsBreakdown: async (surveyId, from, to, breakdownType, surveyFieldId) => {
		const params = {};

		if (from) params.fromDate = from;
		if (to) params.toDate = to;
		if (breakdownType) params.breakdownType = breakdownType;
		if (surveyFieldId) params.surveyFieldId = surveyFieldId;

		const response = await axios({
			method: 'get',
			url: 'private/stats/' + surveyId + '/breakdown',
			baseURL: process.env.MIX_API_URL,
			params,
			headers: {
				Authorization: Spark.jwtToken,
				Accept: 'application/json',
				'Content-Type': 'application/json',
			},
		});

		const stats = await response.data;
		return stats;
	},

	manualStats: async (surveyId, year, month = null) => {
		const params = {};

		let date = new moment(`${year}-${month ? month : 12}-01`, 'YYYY-MM-DD').endOf('month');

		params.fromDate = date.format('YYYY-MM-DD');

		const response = await axios({
			method: 'get',
			url: 'private/manual-stats/' + surveyId,
			baseURL: process.env.MIX_API_URL,
			params,
			headers: {
				Authorization: Spark.jwtToken,
				Accept: 'application/json',
				'Content-Type': 'application/json',
			},
		});

		const stats = await response.data;
		return stats;
	},

	archive: async (surveyId) => {
		try {
			const response = await axios({
				method: 'get',
				url: 'private/surveys/' + surveyId + '/responses/download',
				baseURL: process.env.MIX_API_URL,
				headers: {
					Authorization: Spark.jwtToken,
					Accept: 'application/json',
					'Content-Type': 'application/json',
				},
			});

			const data = await response.data;
			return data;
		} catch (error) {
			console.error(error);
			return error.response.data;
		}
	},

	setStatus: async (surveyId, status) => {
		try {
			const response = await axios({
				method: 'put',
				url: 'private/surveys/' + surveyId + '/setStatus',
				baseURL: process.env.MIX_API_URL,
				data: { status },
				headers: {
					Authorization: Spark.jwtToken,
					Accept: 'application/json',
					'Content-Type': 'application/json',
				},
			});

			const data = await response.data;
			return data;
		} catch (error) {
			console.error(error);
			return error.response.data;
		}
	},

	setPublicStatus: async (surveyId, status) => {
		try {
			const response = await axios({
				method: 'put',
				url: 'private/surveys/' + surveyId + '/setPublicStatus',
				baseURL: process.env.MIX_API_URL,
				data: { status },
				headers: {
					Authorization: Spark.jwtToken,
					Accept: 'application/json',
					'Content-Type': 'application/json',
				},
			});

			const data = await response.data;
			return data;
		} catch (error) {
			console.error(error);
			return error.response.data;
		}
	},

	uploadAdhocEmails: async (surveyId, guests) => {
		try {
			const response = await axios({
				method: 'post',
				url: 'private/surveys/sendAdhocEmails',
				baseURL: process.env.MIX_API_URL,
				data: {
					surveyId,
					guests: guests,
				},
				headers: {
					Authorization: Spark.jwtToken,
					Accept: 'application/json',
					'Content-Type': 'application/json',
				},
			});

			const data = await response.data;
			return data;
		} catch (error) {
			console.error(error);
			return error.response.data;
		}
	},

	getPreviewToken: async (surveyId) => {
		try {
			const response = await axios({
				method: 'get',
				url: 'private/surveys/' + surveyId + '/token?type=preview',
				baseURL: process.env.MIX_API_URL,
				headers: {
					Authorization: Spark.jwtToken,
					Accept: 'application/json',
					'Content-Type': 'application/json',
				},
			});

			const data = await response.data;
			return data;
		} catch (error) {
			console.error(error);
			return error.response.data;
		}
	},

	suggestions: {
		index: async () => {
			const response = await axios({
				method: 'get',
				url: 'private/suggestions',
				baseURL: process.env.MIX_API_URL,
				headers: {
					Authorization: Spark.jwtToken,
					Accept: 'application/json',
					'Content-Type': 'application/json',
				},
			});

			const stats = await response.data;
			return stats;
		},
		markAsPerformed: async (slug) => {
			const response = await axios({
				method: 'post',
				url: 'private/suggestions/markAsPerformed',
				data: { slug },
				baseURL: process.env.MIX_API_URL,
				headers: {
					Authorization: Spark.jwtToken,
					Accept: 'application/json',
					'Content-Type': 'application/json',
				},
			});

			const data = await response.data;
			return data;
		},
	},
	emails: {
		getUnsubscribed: async () => {
			try {
				const response = await axios({
					method: 'get',
					url: 'private/unsubscribed',
					baseURL: process.env.MIX_API_URL,
					headers: {
						Authorization: Spark.jwtToken,
						Accept: 'application/json',
						'Content-Type': 'application/json',
					},
				});
				const data = await response.data.unsubscribed;
				return data;
			} catch (error) {
				console.error(error);
				return error.data ?? error;
			}
		},
		unsubscribe: async (email) => {
			try {
				const response = await axios({
					method: 'post',
					url: 'private/unsubscribe',
					baseURL: process.env.MIX_API_URL,
					data: {
						email: email,
					},
					headers: {
						Authorization: Spark.jwtToken,
						Accept: 'application/json',
						'Content-Type': 'application/json',
					},
				});
				const data = await response.data;
				return data;
			} catch (error) {
				console.error(error);
				return error.data ?? error;
			}
		},
		removeUnsubscribe: async (id) => {
			try {
				const response = await axios({
					method: 'delete',
					url: `private/unsubscribe/${id}`,
					baseURL: process.env.MIX_API_URL,
					headers: {
						Authorization: Spark.jwtToken,
						Accept: 'application/json',
						'Content-Type': 'application/json',
					},
				});
				const data = await response.data;
				return data;
			} catch (error) {
				console.error(error);
				return error.data ?? error;
			}
		},
	},
	bookings: {
		upload: async (formData) => {
			try {
				const response = await axios({
					method: 'post',
					url: 'private/upload/file/bookings',
					baseURL: process.env.MIX_API_URL,
					data: formData,
					headers: {
						Authorization: Spark.jwtToken,
						Accept: 'application/json',
						'Content-Type': 'application/json',
					},
				});

				const data = await response.data;
				return data;
			} catch (error) {
				console.error(error);
				return error.data ?? error;
			}
		},
		index: async (page, filters) => {
			try {
				const response = await axios({
					method: 'get',
					url: 'private/bookings?page=' + page,
					baseURL: process.env.MIX_API_URL,
					params: { filters },
					paramsSerializer: function (params) {
						return Qs.stringify(params, { arrayFormat: 'repeat' });
					},
					headers: {
						Authorization: Spark.jwtToken,
						Accept: 'application/json',
						'Content-Type': 'application/json',
					},
				});

				const data = await response.data;
				return data;
			} catch (error) {
				console.error(error);
				return error.data ?? error;
			}
		},
		calendar: async (filters) => {
			try {
				const response = await axios({
					method: 'get',
					url: 'private/calendar',
					baseURL: process.env.MIX_API_URL,
					params: { filters },
					paramsSerializer: function (params) {
						return Qs.stringify(params, { arrayFormat: 'repeat' });
					},
					headers: {
						Authorization: Spark.jwtToken,
						Accept: 'application/json',
						'Content-Type': 'application/json',
					},
				});

				const data = await response.data;
				return data;
			} catch (error) {
				console.error(error);
				return error.data ?? error;
			}
		},
	},

	credits: {
		index: async () => {
			const response = await axios({
				method: 'get',
				url: 'private/plan/credits',
				baseURL: process.env.MIX_API_URL,
				headers: {
					Authorization: Spark.jwtToken,
					'Content-Type': 'multipart/form-data',
				},
			});

			const data = await response.data;
			return data;
		},
	},

	plan: {
		update: async (teamId, plan) => {
			try {
				const response = await axios({
					method: 'post',
					baseURL: process.env.MIX_API_URL,
					headers: {
						Authorization: Spark.jwtToken,
						Accept: 'application/json',
						'Content-Type': 'application/json',
					},
					data: {
						plan: plan,
					},
					url: `private/plan/${teamId}`,
				});

				const results = await response.data;
				return results;
			} catch (error) {
				console.error(error);
				return error.data ?? error;
			}
		},
	},

	archives: {
		get: async () => {
			const response = await axios({
				method: 'get',
				url: 'private/archives',
				baseURL: process.env.MIX_API_URL,
				headers: {
					Authorization: Spark.jwtToken,
					'Content-Type': 'multipart/form-data',
				},
			});

			const data = await response.data;
			return data;
		},
		download: async (archiveId) => {
			try {
				const response = await axios({
					baseURL: process.env.MIX_API_URL,
					url: 'private/archives/' + archiveId,
					method: 'GET',
					responseType: 'blob',
					headers: {
						Authorization: Spark.jwtToken,
					},
				});

				const data = await response.data;
				const url = window.URL.createObjectURL(new Blob([data]));
				const link = document.createElement('a');
				link.href = url;
				link.setAttribute('download', 'archive.zip');
				document.body.appendChild(link);
				link.click();
			} catch (error) {
				return new Promise((resolve) => {
					const reader = new FileReader();

					reader.onload = async function () {
						resolve(JSON.parse(reader.result));
					};

					reader.readAsText(error.response.data);
				});
			}
		},
	},

	responses: {
		index: async (page = 1, filters = {}) => {
			const response = await axios({
				method: 'get',
				url: 'private/surveys/responses?page=' + page,
				baseURL: process.env.MIX_API_URL,
				params: { filters },
				paramsSerializer: function (params) {
					return Qs.stringify(params, { arrayFormat: 'repeat' });
				},
				headers: {
					Authorization: Spark.jwtToken,
					Accept: 'application/json',
					'Content-Type': 'application/json',
				},
			});

			const results = await response.data;
			return results;
		},
		get: async (id) => {
			const response = await axios({
				method: 'get',
				url: 'private/surveys/responses/' + id,
				baseURL: process.env.MIX_API_URL,
				headers: {
					Authorization: Spark.jwtToken,
					Accept: 'application/json',
					'Content-Type': 'application/json',
				},
			});

			const results = await response.data;
			return results;
		},
		respond: async (id, message) => {
			try {
				const response = await axios({
					method: 'post',
					url: 'private/surveys/respond',
					baseURL: process.env.MIX_API_URL,
					data: {
						id,
						message,
					},
					headers: {
						Authorization: Spark.jwtToken,
						Accept: 'application/json',
						'Content-Type': 'application/json',
					},
				});

				const results = await response.data;
				return results;
			} catch (error) {
				console.error(error);
				return error.data ?? error;
			}
		},
		delete: async (responseId) => {
			const response = await axios({
				method: 'delete',
				url: 'private/surveys/responses/' + responseId,
				baseURL: process.env.MIX_API_URL,
				headers: {
					Authorization: Spark.jwtToken,
					Accept: 'application/json',
					'Content-Type': 'application/json',
				},
			});

			const results = await response.data;
			return results;
		},
	},
	responseTemplates: {
		index: async () => {
			try {
				const response = await axios({
					method: 'get',
					url: 'private/surveys/response-templates',
					baseURL: process.env.MIX_API_URL,
					headers: {
						Authorization: Spark.jwtToken,
						Accept: 'application/json',
						'Content-Type': 'application/json',
					},
				});

				const results = await response.data;
				return results;
			} catch (error) {
				console.error(error);
				return error.data ?? error;
			}
		},
		delete: async (templateId) => {
			const response = await axios({
				method: 'delete',
				url: `private/surveys/response-templates/${templateId}`,
				baseURL: process.env.MIX_API_URL,
				headers: {
					Authorization: Spark.jwtToken,
					Accept: 'application/json',
					'Content-Type': 'application/json',
				},
			});
			return response.data;
		},
		create: async (label, body) => {
			try {
				const response = await axios({
					method: 'post',
					url: 'private/surveys/response-templates/create',
					baseURL: process.env.MIX_API_URL,
					data: {
						label,
						body,
					},
					headers: {
						Authorization: Spark.jwtToken,
						Accept: 'application/json',
						'Content-Type': 'application/json',
					},
				});

				const results = await response.data;
				return results;
			} catch (error) {
				console.error(error);
				return error.data ?? error;
			}
		},
	},
	reports: {
		download: async (responseId) => {
			try {
				await axios({
					baseURL: process.env.MIX_API_URL,
					url: 'private/surveys/responses/' + responseId + '/report',
					method: 'GET',
					responseType: 'blob',
					headers: {
						Authorization: Spark.jwtToken,
					},
				}).then((response) => {
					const url = window.URL.createObjectURL(new Blob([response.data]));
					const link = document.createElement('a');
					link.href = url;
					link.setAttribute('download', 'report.pdf');
					document.body.appendChild(link);
					link.click();
				});
			} catch (error) {
				return new Promise((resolve) => {
					const reader = new FileReader();

					reader.onload = async function () {
						resolve(JSON.parse(reader.result));
					};

					reader.readAsText(error.response.data);
				});
			}
		},
	},
	segments: {
		index: async () => {
			const response = await axios({
				method: 'get',
				url: 'private/segments',
				baseURL: process.env.MIX_API_URL,
				headers: {
					Authorization: Spark.jwtToken,
					Accept: 'application/json',
					'Content-Type': 'application/json',
				},
			});

			const results = await response.data;
			return results;
		},
	},
	topics: {
		index: async () => {
			const response = await axios({
				method: 'get',
				url: 'private/topics',
				baseURL: process.env.MIX_API_URL,
				headers: {
					Authorization: Spark.jwtToken,
					Accept: 'application/json',
					'Content-Type': 'application/json',
				},
			});

			const results = await response.data;
			return results;
		},
		create: async (topic) => {
			try {
				const response = await axios({
					method: 'post',
					url: 'private/topics',
					baseURL: process.env.MIX_API_URL,
					data: topic,
					headers: {
						Authorization: Spark.jwtToken,
						Accept: 'application/json',
						'Content-Type': 'application/json',
					},
				});

				const results = await response.data;
				return results;
			} catch (error) {
				console.error(error);
				return error.data ?? error;
			}
		},
		update: async (id, topic) => {
			try {
				const response = await axios({
					method: 'put',
					url: 'private/topics/' + id,
					baseURL: process.env.MIX_API_URL,
					data: topic,
					headers: {
						Authorization: Spark.jwtToken,
						Accept: 'application/json',
						'Content-Type': 'application/json',
					},
				});

				const results = await response.data;
				return results;
			} catch (error) {
				console.error(error);
				return error.data ?? error;
			}
		},
		delete: async (id) => {
			try {
				const response = await axios({
					method: 'delete',
					url: 'private/topics/' + id,
					baseURL: process.env.MIX_API_URL,
					headers: {
						Authorization: Spark.jwtToken,
						Accept: 'application/json',
						'Content-Type': 'application/json',
					},
				});

				const results = await response.data;
				return results;
			} catch (error) {
				console.error(error);
				return error.data ?? error;
			}
		},
	},
	sentiment: {
		index: async (surveyId, fromDate, toDate) => {
			try {
				const response = await axios({
					method: 'get',
					baseURL: process.env.MIX_API_URL,
					headers: {
						Authorization: Spark.jwtToken,
						Accept: 'application/json',
						'Content-Type': 'application/json',
					},
					url: `private/surveys/${surveyId}/responses/terms?fromDate=${fromDate}&toDate=${toDate}`,
				});

				const results = await response.data;
				return results;
			} catch (error) {
				console.error(error);
				return error.data ?? error;
			}
		},
		getOverview: async (surveyId, fromDate, toDate) => {
			try {
				const response = await axios({
					method: 'get',
					baseURL: process.env.MIX_API_URL,
					headers: {
						Authorization: Spark.jwtToken,
						Accept: 'application/json',
						'Content-Type': 'application/json',
					},
					url: `private/surveys/${surveyId}/overview/trends?fromDate=${fromDate}&toDate=${toDate}`,
				});

				const results = await response.data;
				return results;
			} catch (error) {
				console.error(error);
				return error.data ?? error;
			}
		},
		getGroupStats: async (surveyId, fromDate, toDate) => {
			try {
				const response = await axios({
					method: 'get',
					baseURL: process.env.MIX_API_URL,
					headers: {
						Authorization: Spark.jwtToken,
						Accept: 'application/json',
						'Content-Type': 'application/json',
					},
					url: `private/surveys/${surveyId}/responses/group-stats?fromDate=${fromDate}&toDate=${toDate}`,
				});

				const results = await response.data;
				return results;
			} catch (error) {
				console.error(error);
				return error.data ?? error;
			}
		},
		getAllStats: async (surveyId, fromDate, toDate) => {
			try {
				const response = await axios({
					method: 'get',
					baseURL: process.env.MIX_API_URL,
					headers: {
						Authorization: Spark.jwtToken,
						Accept: 'application/json',
						'Content-Type': 'application/json',
					},
					url: `private/surveys/${surveyId}/responses/stats?fromDate=${fromDate}&toDate=${toDate}`,
				});

				const results = await response.data;
				return results;
			} catch (error) {
				console.error(error);
				return error.data ?? error;
			}
		},
		getActiveGroupTimeseries: async (surveyId, fromDate, toDate, groupName) => {
			try {
				const response = await axios({
					method: 'get',
					baseURL: process.env.MIX_API_URL,
					headers: {
						Authorization: Spark.jwtToken,
						Accept: 'application/json',
						'Content-Type': 'application/json',
					},
					url: `private/surveys/${surveyId}/responses/group-timeseries?fromDate=${fromDate}&toDate=${toDate}&group=${groupName}`,
				});

				const results = await response.data;
				return results;
			} catch (error) {
				console.error(error);
				return error.data ?? error;
			}
		},
		getActiveGroupTopics: async (surveyId, fromDate, toDate, groupName) => {
			try {
				const response = await axios({
					method: 'get',
					baseURL: process.env.MIX_API_URL,
					headers: {
						Authorization: Spark.jwtToken,
						Accept: 'application/json',
						'Content-Type': 'application/json',
					},
					url: `private/surveys/${surveyId}/responses/group-breakdown?fromDate=${fromDate}&toDate=${toDate}&group=${groupName}`,
				});

				const results = await response.data;
				return results;
			} catch (error) {
				console.error(error);
				return error.data ?? error;
			}
		},
	},
};

export default SurveysService;
